import React, { useCallback, useEffect, useRef } from "react";
import "../../../../styles/kanbans/modals/delete-job-modals.css";

export type DeleteJobModalProps = {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  closeOnOverlay?: boolean;
};

export default function DeleteJobModal({
  open,
  title = "Delete Job",
  message = "Are you sure you want to delete this job? This will also delete any job tailored resume and application packet associated with it.",
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  closeOnOverlay = true,
}: DeleteJobModalProps) {
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const delBtnRef = useRef<HTMLButtonElement | null>(null);

  const onEsc = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    },
    [onCancel]
  );

  useEffect(() => {
    if (!open) return;
    document.addEventListener("keydown", onEsc);
    const t = setTimeout(() => delBtnRef.current?.focus(), 0);
    return () => {
      document.removeEventListener("keydown", onEsc);
      clearTimeout(t);
    };
  }, [open, onEsc]);

  if (!open) return null;

  return (
    <div
      className="djm-ov"
      ref={overlayRef}
      onMouseDown={(e) => {
        if (!closeOnOverlay) return;
        if (e.target === overlayRef.current) onCancel();
      }}
      aria-hidden={!open}
    >
      <section
        className="djm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="djm-title"
      >
        <header className="djm-h">
          <h2 id="djm-title" className="djm-title">
            {title}
          </h2>
        </header>

        <div className="djm-b">
          <p className="djm-msg">{message}</p>
        </div>

        <footer className="djm-f">
          <button
            ref={delBtnRef}
            type="button"
            className="djm-btn djm-btn-danger"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
          <button
            type="button"
            className="djm-btn djm-btn-ghost"
            onClick={onCancel}
          >
            {cancelText}
          </button>
        </footer>
      </section>
    </div>
  );
}